import {request, formatter, ResponseStatus} from '@/utils/request';
import download from "@/utils/download";
import {message, notification} from "antd";

export namespace DownloadCenter {

  export const Path = {
    Download: '/fileapi/downloadCenter/downloadGeneratedFile',
    Cancel: '/fileapi/downloadCenter/cancelDownloadFile',
    Delete: '/fileapi/downloadCenter/deleteDownloadFile',
    Query: '/fileapi/downloadCenter/queryDownloadFile',
    CurrentDownloadingNumber: '/fileapi/downloadCenter/currentDownloadingNumber',
    CurrentCompleteNumber: '/fileapi/downloadCenter/currentCompleteNumber'
  };

  export async function downloadFile(record: any) {
    await download(
      DownloadCenter.Path.Download,
      formatter({method: 'GET', body: {fileKey: record.fileKey}}),
      record.fileName
    );
  }

  export async function cancel(body: API.DownloadFile) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.Cancel, formatter(options));
  }

  export async function del(body: API.DownloadFile) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.DownloadFile>>(Path.Query, formatter(options));
  }

  export async function currentDownloadingNumber() {
    const options = {
      method: 'POST',
      body: {},
    };
    return request<API.ResponseResult<number>>(Path.CurrentDownloadingNumber, formatter(options));
  }

  export async function currentCompleteNumber() {
    const options = {
      method: 'POST',
      body: {},
    };
    return request<API.ResponseResult<number>>(Path.CurrentCompleteNumber, formatter(options));
  }

  export const updateBudged = async (initialState: any, setInitialState: any): Promise<void> => {
    const responseComplete = await currentCompleteNumber();
    if (responseComplete.code != ResponseStatus.SUCCESS) {
      message.error(responseComplete.message);
      return;
    }
    const completeNumber: number = responseComplete.data;
    initialState.fileCounter = completeNumber;
    setInitialState(initialState);

    // console.log("已生成待下载的文件数量: " + completeNumber);
  }

  let refreshPageFun: any;
  export const setRefreshPageFun = (refreshFun: any) => {refreshPageFun = refreshFun};

  export const updateDownloadFile = async (initialState: any, setInitialState: any): Promise<void> => {
    // @ts-ignore
    if (initialState.fileUpdating) {
      return;
    }
    // @ts-ignore
    initialState.fileUpdating = false;
    setInitialState(initialState);
    let num = 0;
    let i = 1;
    do {
      const response = await currentDownloadingNumber();
      if (response.code != ResponseStatus.SUCCESS) {
        message.error(response.message);
        return;
      }
      const numTemp: number = response.data;

      initialState.fileUpdating = (numTemp != 0);
      setInitialState(initialState);

      if (i == 1) {
        num = numTemp;
      } else {
        if (initialState.fileUpdating) {
          await new Promise(resolve => setTimeout(resolve, 10000));
        }
        if (num != numTemp) {
          // message.info("您的文件已经生成成功, 可以前往下载中心进行下载")
          notification.success({message: "下载提醒", description: "您的文件已经生成成功, 可以前往下载中心进行下载", placement: "bottomRight", duration: 1000});
          // gridReload();
          if (refreshPageFun) {
            refreshPageFun();
          }
          updateBudged(initialState, setInitialState);
          // downloadCenterReload();
          num = numTemp;
        }
      }
      i++;
    } while (initialState.fileUpdating);
  }
}
